import { useGetApiClient } from "api/get-api-client";
import getErrorMessage from "api/get-error-message";
import { ModalConfirm } from "components/modal-confirm";
import { useToast } from "contexts/toast";
import React from "react";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

type Props = {
  onClose: () => void;
};

export const SubscriptionRefillModal = ({ onClose }: Props) => {
  const apiClient = useGetApiClient();
  const navigate = useNavigate();
  const { addToast } = useToast();

  const onRefill = async () => {
    try {
      const res = await apiClient.billing.subscriptionRefill();
      if (res.data.paid) {
        addToast("We're processing your payment. Thank you!", {
          appearance: "success",
        });
      } else {
        navigate(paths.invoiceFailedId(res.data.invoiceId));
      }
    } catch (e) {
      addToast(getErrorMessage(e) || "An error occurred, please try again.", {
        appearance: "error",
      });
    }
  };

  return (
    <ModalConfirm
      confirmationButtonColor="green"
      confirmationButtonText="Refill credits"
      confirmationMessage='By clicking "Refill Credits", your subscription billing cycle will be renewed immediately, your payment method will be charged, and you will receive your credits right away.'
      confirmationTitle="Restart your billing cycle"
      onClose={() => onClose()}
      onConfirm={onRefill}
    />
  );
};
